<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
    transition="fade-transition"
    v-model="datePickerVisible"
  >
    <template #activator="props">
      <slot name="activator" v-bind="{ ...props, displayValue }" />
    </template>
    <v-date-picker
      :value="value"
      :picker-date.sync="pickerDate"
      @input="onSelect"
      :type="type"
      :max="max"
      no-title
      scrollable
      :locale="$i18n.locale"
      :day-format="dayFormat"
      v-bind="datePickerProps"
    />
  </v-menu>
</template>

<script>
import { format } from 'date-fns';
import dateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'date-picker-dropdown',
  mixins: [dateTimeFormatting],
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'date',
    },
    max: {
      type: String,
    },
    datePickerProps: {
      type: Object,
      default: () => ({}),
    },
    displayFormat: {
      type: String,
      default: 'yyyy/MM/dd',
    },
  },
  computed: {
    displayValue() {
      if (!this.value) return '';
      return this.formatLocalized(this.value, this.displayFormat);
    },
    pickerDateFormat() {
      return this.type === 'month' ? 'yyyy' : 'yyyy-MM';
    },
  },
  data() {
    return {
      datePickerVisible: false,
      pickerDate: null,
    };
  },
  watch: {
    // メニューが開く度に、value 基準（または今日）で表示月をリセットする。
    // 閉じた際の最終表示月を保持させない（前回の picker 表示月の残留防止）。
    datePickerVisible(visible) {
      if (!visible) return;
      const baseDate = this.value ? new Date(this.value) : new Date();
      this.pickerDate = format(baseDate, this.pickerDateFormat);
    },
  },
  methods: {
    dayFormat(date) {
      return this.formatLocalized(date, 'd');
    },
    onSelect(date) {
      this.datePickerVisible = false;
      this.$emit('input', date);
    },
  },
};
</script>
